import { Route } from "react-router-dom";
import { HomePage } from "@/pages/Home";
import { loginLoader } from "@/router/loaders/loginLoader";
import { RouterPath } from "@/router/types";
import { PageSpinner } from "@/shared/ui/PageSpinner";
import { LayoutBaseFooter } from "@/widgets/Layout/BaseFooter";

export const commonRouter = (
  <Route element={<LayoutBaseFooter />} HydrateFallback={PageSpinner}>
    <Route path="/" element={<HomePage />} HydrateFallback={PageSpinner} />
    <Route
      path="/payment-common"
      lazy={() =>
        import(
          /* webpackChunkName: "payment-common-page", webpackPrefetch: true */ "@/pages/PaymentCommon"
        )
      }
      HydrateFallback={PageSpinner}
    />
    <Route
      path={RouterPath.Login}
      loader={loginLoader}
      lazy={() =>
        import(
          /* webpackChunkName: "login-page", webpackPrefetch: true */ "@/pages/Login"
        )
      }
      HydrateFallback={PageSpinner}
    />
    {/* TODO: signup loader ??? */}
    <Route
      path="/signup"
      lazy={() =>
        import(
          /* webpackChunkName: "signup-page", webpackPrefetch: true */ "@/pages/Signup"
        )
      }
      HydrateFallback={PageSpinner}
    />
    <Route
      path="/mock/:date/:iin"
      lazy={() => import("@/pages/Backdoor")}
      HydrateFallback={PageSpinner}
    />
  </Route>
);
